import { AdminUsersRole } from 'stores/users/types';
import { defaultSelectStyles } from 'components/Inputs/SelectComponent/selectCustomStyles';

export const availableRoles: AdminUsersRole[] = ['super-admin', 'admin'];

// export const deletedStatusOptions: IDeletedStatusOption[] = [
//   { id: 'true', name: 'deleted' },
//   { id: 'false', name: 'notDeleted' },
// ];

export const DEFAULT_SELECT_STYLES = {
  ...defaultSelectStyles,
  selectStyle: { minWidth: 170, maxWidth: 300, flex: '2 1 100%' },
};
